import magnificPopup from "magnific-popup";

var fluxLoginButtons = {};

/**
 * Run.
 */
fluxLoginButtons.init = function() {
    this.onClick();

    /**
     * If auto-open class is present in the login for i.e. user has entered a wrong password,
     * Then open the login form automatically.
     */
    if ( jQuery( '.woocommerce-form-login' ).hasClass( 'woocommerce-form-login--auto-open' ) ) { 
        window.setTimeout( function () {
            fluxLoginButtons.openPopup();
        }, 1000 );
    }
};

/**
 * Login Buttons On Click.
 * 
 * Handle the show and hide of the login form from a custom button.
 */
fluxLoginButtons.onClick = function () {
    jQuery( document ).on( 'click', '[data-login]', function ( e ) {
        e.preventDefault();
        fluxLoginButtons.openPopup();
    } );
};

/**
 * Open popup.
 */
fluxLoginButtons.openPopup = function () {
    jQuery.magnificPopup.open( {
        items: {
            src: '.woocommerce-form-login',
            type: 'inline'
        }
    } );
};

export default fluxLoginButtons;